import http from "../httpService";
import { apiUrl } from "../../../config.js";
const apiEndpoint = apiUrl + "/sales/sales-report/";

export function getSalesDashboard(fiscalYearID = 0, fiscalPeriodID = 0) {
  return http.get(
    apiEndpoint + "sales-dashboard/" + fiscalYearID + "/" + fiscalPeriodID
  );
}

export function getSalesOrderSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "sales-order-summary/" + fiscalYearID);
}

export function getSalesTargetSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "sales-target-summary/" + fiscalYearID);
}

export function getTopCustomersSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-customers-summary/" + fiscalPeriodID);
}

export function getTopSalesItemsSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-sales-items-summary/" + fiscalPeriodID);
}

export function getTopSalesmansSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-salesmans-summary/" + fiscalPeriodID);
}

export function getWonLostSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "won-lost-summary/" + fiscalYearID);
}

export function getOrderByCustomerTypeSummary(fiscalYearID = 0) {
  return http.get(
    apiEndpoint + "order-by-customer-type-summary/" + fiscalYearID
  );
}

export function getSalesOverviewReport() {
  return http.get(apiEndpoint + "sales-overview-report");
}

export function getCustomerAnalyticsReport() {
  return http.get(apiEndpoint + "customer-analytics-report");
}

export function getOutletSalesReport() {
  return http.get(apiEndpoint + "outlet-sales-report");
}

export function getSalesTargetReport(fiscalYearID = 0) {
  return http.get(apiEndpoint + "sales-target-report/" + fiscalYearID);
}
